import React from 'react';
export function CaseStudy() {
  return <section className="py-[60px] px-6 md:py-[120px] md:px-[72px]" id="resultados" data-id="element-21">
      <div className="max-w-[1200px] mx-auto" data-id="element-22">
        <div className="inline-flex items-center gap-2.5 text-[10px] tracking-[3px] uppercase text-gold mb-5 font-medium" data-id="element-23">
          <span className="w-6 h-px bg-gold" data-id="element-24"></span>
          Caso de Éxito Real
        </div>

        <h2 className="font-serif text-[clamp(38px,4vw,62px)] font-light leading-[1.08] tracking-tight mb-5 text-cream" data-id="element-25">
          Ayudamos a Dany Credit a pasar de
          <br data-id="element-26" />6 cifras al{' '}
          <em className="italic text-gold-bright" data-id="element-27">millón de dólares.</em>
        </h2>

        <p className="text-[17px] text-muted max-w-[520px] leading-relaxed" data-id="element-28">
          Empezaron con nosotros ya generando ingresos de 6 cifras. La meta era
          el millón — y la logramos juntos.
        </p>

        <div className="mt-10 md:mt-[70px]" data-id="element-29">
          <div className="grid grid-cols-1 md:grid-cols-2 border border-subdued bg-surface relative overflow-hidden" data-id="element-30">
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold to-transparent" data-id="element-31" />

            {/* Left Column */}
            <div className="p-6 md:py-16 md:px-15 border-b md:border-b-0 md:border-r border-subdued" data-id="element-32">
              <div className="text-[10px] tracking-[2.5px] uppercase text-gold mb-8 font-medium flex items-center gap-2" data-id="element-33">
                <span className="w-4 h-px bg-gold" data-id="element-34"></span>
                Caso de Estudio — Dany Credit
              </div>

              <h3 className="font-serif text-[36px] font-light leading-[1.15] tracking-tight mb-6 text-cream" data-id="element-35">
                De un pipeline inconsistente a un sistema que genera clientes
                todos los días.
              </h3>

              <p className="text-[15px] text-muted leading-relaxed mb-4" data-id="element-36">
                Antes de trabajar con nosotros, Dany Credit ya tenía un negocio
                funcionando con ingresos de 6 cifras — pero el crecimiento era
                inconsistente. Los leads llegaban sin un sistema real detrás:
                sin CRM, sin automatización, sin calificación estructurada.
              </p>

              <p className="text-[15px] text-muted leading-relaxed mb-4" data-id="element-37">
                Construimos su motor completo de generación de leads: campañas
                de Meta Ads especializadas para el nicho, automatización de
                seguimiento vía GoHighLevel, y un proceso de ventas que
                convirtió leads en clientes pagantes de forma consistente. El
                resultado: el millón de dólares en facturación.
              </p>

              <div className="grid grid-cols-2 gap-px bg-subdued mt-11" data-id="element-38">
                <div className="bg-mid p-6 md:py-7 md:px-6" data-id="element-39">
                  <span className="font-serif text-[38px] font-semibold text-gold-bright block mb-1.5 leading-none" data-id="element-40">
                    $1M+
                  </span>
                  <span className="text-[13px] text-muted" data-id="element-41">
                    Hito de facturación alcanzado
                  </span>
                </div>
                <div className="bg-mid p-6 md:py-7 md:px-6" data-id="element-42">
                  <span className="font-serif text-[38px] font-semibold text-gold-bright block mb-1.5 leading-none" data-id="element-43">
                    ↓60%
                  </span>
                  <span className="text-[13px] text-muted" data-id="element-44">
                    Reducción en costo por lead
                  </span>
                </div>
                <div className="bg-mid p-6 md:py-7 md:px-6" data-id="element-45">
                  <span className="font-serif text-[38px] font-semibold text-gold-bright block mb-1.5 leading-none" data-id="element-46">
                    800+
                  </span>
                  <span className="text-[13px] text-muted" data-id="element-47">
                    Leads calificados por mes
                  </span>
                </div>
                <div className="bg-mid p-6 md:py-7 md:px-6" data-id="element-48">
                  <span className="font-serif text-[38px] font-semibold text-gold-bright block mb-1.5 leading-none" data-id="element-49">
                    3×
                  </span>
                  <span className="text-[13px] text-muted" data-id="element-50">
                    Crecimiento en volumen de clientes
                  </span>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="p-6 md:py-16 md:px-15 flex flex-col" data-id="element-51">
              <div className="font-serif text-[120px] leading-[0.6] text-gold opacity-20 mb-1 font-semibold" data-id="element-52">
                "
              </div>
              <p className="font-serif text-[22px] font-light italic leading-relaxed text-[#c8c0b4] mb-10 flex-1" data-id="element-53">
                Trabajar con este equipo cambió completamente cómo conseguimos
                clientes. Antes perseguía leads manualmente. Ahora tenemos un
                sistema que corre solo y trae personas calificadas todos los
                días. Llegamos al millón y no nos vamos a detener ahí.
              </p>

              <div className="flex items-center gap-4.5" data-id="element-54">
                <div className="w-[52px] h-[52px] rounded-full border border-gold-line bg-gold-pale flex items-center justify-center font-serif text-[22px] font-semibold text-gold-bright shrink-0" data-id="element-55">
                  D
                </div>
                <div data-id="element-56">
                  <div className="text-[15px] font-medium text-cream mb-1" data-id="element-57">
                    Dany Credit
                  </div>
                  <div className="text-xs text-muted tracking-wide" data-id="element-58">
                    Fundador · Agencia de Reparación de Crédito
                  </div>
                </div>
              </div>

              <div className="mt-10 pt-10 border-t border-subdued" data-id="element-59">
                <div className="flex items-center justify-between mb-5" data-id="element-60">
                  <div className="text-[14px] font-medium text-cream" data-id="element-61">
                    Ver el testimonio completo de Dany
                  </div>
                  <div className="text-xs text-muted" data-id="element-62">
                    Video testimonio · 2 min
                  </div>
                </div>
                <video src="https://cdn.magicpatterns.com/uploads/qR3WJPToLX4dtfgkPxh6hR/0324.mp4" controls className="w-full max-w-[320px] rounded-xl border border-gold-line shadow-[0_8px_32px_rgba(184,151,58,0.15)] bg-ink" data-id="element-63" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}